import { Component, AfterViewInit, Input, Output, EventEmitter, NgZone } from "@angular/core";
import { environment } from 'environments/environment';
import { logging } from 'protractor';

declare var gapi;

@Component({
  selector: 'ga-date-range-selector',
  templateUrl: './ga-date-range-selector.component.html'
})
export class GADateRangeSelectorComponent implements AfterViewInit {


  @Input()
  ids: string;

  @Input()
  startDate: string = '7daysAgo';

  @Input()
  endDate: string = 'today';

  @Output()
  startDateChange = new EventEmitter();

  @Output()
  endDateChange = new EventEmitter();

  constructor(private zone: NgZone) {

  }


  ngAfterViewInit(): void {
    var dateRangeSelector = new gapi.analytics.ext.DateRangeSelector({
      container: 'date-range-selector-container'
    }).set({
      'start-date': this.startDate,
      'end-date': this.endDate,
    }).execute();

    dateRangeSelector.on('change', data => {
      this.zone.run(() => {
        console.log('date changed');

        this.startDate = data["start-date"];
        this.endDate = data["end-date"];

        this.startDateChange.emit(this.startDate);
        this.endDateChange.emit(this.endDate);
      });
    });
  }
}
